var _defs, _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFinnitNavMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "finnit_nav_menu_svg__Ebene_1",
  "data-name": "Ebene 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17.47 16.7"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".finnit_nav_menu_svg__cls-1{stroke-miterlimit:10;stroke-width:.75px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  className: "finnit_nav_menu_svg__cls-1",
  x: 360.83,
  y: 12.81,
  width: 2.61,
  height: 16.72,
  rx: 1.03,
  transform: "rotate(90 195.18 -165.27)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  className: "finnit_nav_menu_svg__cls-1",
  x: 360.83,
  y: 19.48,
  width: 2.61,
  height: 16.72,
  rx: 1.03,
  transform: "rotate(90 195.185 -158.605)"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  className: "finnit_nav_menu_svg__cls-1",
  x: 360.83,
  y: 26.15,
  width: 2.61,
  height: 16.72,
  rx: 1.03,
  transform: "rotate(90 195.185 -151.935)"
})));

export default SvgFinnitNavMenu;